import { useState } from "react";
import { QuestionType } from "../preViewQuiz";
import { Botao } from "../../../../../../../../assets/images";
import { useTranslation } from "_metronic/i18n/language";
import "./style.scss";
import PreviewButton from "../components/PreviewButton";
import ChildIdentificationAnswers from "./ChildIdentificationAnswers";
import { IconButton } from "@mui/material";
import { PlayCircle } from "@mui/icons-material";
import clsx from "clsx";

type PreviewChildIdentificationHCProps = {
  selectedAnswerId: number | null;
  currentQuestionIndex: number;
  questionsLength: number;
  currentQuestion: QuestionType;
  handleSelectAnswer: (answerId: number) => void;
  handleNextQuestion: () => void;
};

const PreviewChildIdentificationHC = ({
  currentQuestion,
  selectedAnswerId,
  currentQuestionIndex,
  questionsLength,
  handleSelectAnswer,
  handleNextQuestion
}: PreviewChildIdentificationHCProps) => {
  const [shots, setShots] = useState(3);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [enabledButtons, setEnabledButtons] = useState(false);
  const translate = useTranslation();

  const handleButtonSmell = () => {
    setEnabledButtons(true);
    if (shots > 0) {
      setShots(prevShots => prevShots - 1);
    }
  };

  const handleNextClick = () => {
    if (currentQuestionIndex + 1 >= questionsLength) {
      return;
    }
    setShots(3);
    handleNextQuestion();
    setEnabledButtons(false);
    setIsNextButtonEnabled(false);
  };

  const handleEnableNextButton = () => setIsNextButtonEnabled(true);

  return (
    <div className="preview-inner-content-hc">
      <div className="progress-bar">
        {translate("screens_quiz_labels_question")} {currentQuestionIndex + 1} /{" "}
        {questionsLength}
      </div>
      <div className="question-title">
        <span>{currentQuestion.question.quest}</span>
      </div>
      <div>
        <ChildIdentificationAnswers
          answers={currentQuestion.answers}
          enabledButtons={enabledButtons}
          selectedAnswerId={selectedAnswerId}
          handleAnswerClick={answerId => {
            handleSelectAnswer(answerId);
            handleEnableNextButton();
          }}
        >
          <div className="smell-red-wrapper">
            <PreviewButton
              onClick={handleButtonSmell}
              className="btn-smell-red"
              style={{
                backgroundImage: `url(${Botao})`
              }}
              label={
                <div
                  className={clsx("smell-red-label", {
                    "smell-red-label-disabled": shots === 0
                  })}
                >
                  {`${translate("screenApp_quiz_tryScent")}  !`
                    .split(" ")
                    .map((word, index) => (
                      <span key={index}>{word}</span>
                    ))}
                </div>
              }
              disabled={shots === 0}
            />
          </div>
        </ChildIdentificationAnswers>
        <div className="actions-footer">
          <div className="footer-shots">
            <div className="footer-shots-title">
              {translate("screenApp_quiz_messageShotsAvailableHC")}
            </div>
            <div className="footer-shots-value">
              {translate("screenApp_quiz_messageShotsAvailableHCShots", {
                shots: shots
              })}
            </div>
          </div>
          <div className="btn-next-container-hc">
            <span className="btn-next-hc">
              {translate("screenApp.validation.next")}
            </span>
            <IconButton
              title="Próximo"
              onClick={handleNextClick}
              disabled={!isNextButtonEnabled}
              style={{ color: "#00b200" }}
            >
              <PlayCircle />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewChildIdentificationHC;
